module.exports = __webpack_public_path__ + "images/newerp_icon1.1790731042052.png";